import { useState } from "react";
import { Search, Download, ChevronDown } from "lucide-react";
import "../Assets/css/influencer.css";
import Logo from "../Assets/Img/payment_Company_logo.png";
import { Link } from "react-router-dom";
import nopayment from "../Assets/Img/No Payment.png";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export default function PaymentsDashboard() {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(30);


  const payments = [
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
    {
      id: "51468",
      brandName: "Puma",
      campaignName: "Secret Santa",
      billingDate: "2/19/23",
      amount: 5000,
      status: "Paid",
    },
  ]; // Assuming no payments for this case

  const filteredPayments = payments.filter(
    (payment) =>
      payment.brandName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      payment.campaignName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const toggleSort = () => {
    setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const sortedPayments = [...filteredPayments].sort((a, b) => {
    const dateA = new Date(a.billingDate);
    const dateB = new Date(b.billingDate);
    return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
  });

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = sortedPayments.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(sortedPayments.length / recordsPerPage);

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handleRecordsPerPageChange = (e) => {
    setRecordsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  // Show Only No Payment Image if No Data
  if (currentRecords.length === 0) {
    return (
      <div
        className="no-data-full-page d-flex flex-column justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <img src={nopayment} alt="No Payments" className="no-data-image" />
        <h2 className="mt-3">Welcome to Payments!</h2>
        <p>It looks like there are no transactions yet.</p>
        <p>Ready to make your first payment?</p>
      </div>
    );
  }

  const handleDownloadPDF = async () => {
    const doc = new jsPDF();
  
    // Load logo image (convert to base64 first)
    const logoImg = new Image();
    logoImg.src = Logo;
  
    // Wait for the logo to load
    logoImg.onload = () => {
      // Draw the logo at the top-left
      doc.addImage(logoImg, 'PNG', 10, 10, 40, 20);
  
      // Add the title on the top-right
      doc.setFontSize(12);
      doc.text('Payment Details', 150, 10, { marginLeft: 'right' });
  
      // Add spacing before table
      autoTable(doc, {
        startY: 30,
        head: [['Sr No.', 'Payment ID', 'Brand Name', 'Campaign Name', 'Billing Date', 'Amount', 'Status']],
        body: payments.map((item, index) => [
          index + 1,
          item.paymentId,
          item.brandName,
          item.campaignName,
          item.billingDate,
          item.amount,
          item.status,
        ]),
        styles: {
          fontSize: 10,
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [41, 128, 185], // Optional blue header
          textColor: [255, 255, 255],
        },
      });
  
      doc.save('insocialorbit_payment_details.pdf');
    };
  };


  return (
    <div className="payments-dashboard">
      <div className="container-fluid py-0">
        <div className="header mb-4">
          <div className="mb-3">
            {/* <h1 className="payments-title">Payments</h1> */}
            <div className="d-flex align-items-center subtitle-container">
              <p className="subtitle mb-0">
                Manage your billing and payment details
              </p>
              <Link to="/payment-method" className="view-payment-link ms-3">
                View Payment Method
              </Link>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center">
            <div className="search-container">
              <Search className="search-icon" size={20} />
              <input
                type="text"
                placeholder="Search"
                className="search-input"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <button className="download-btn" onClick={handleDownloadPDF}>
              <Download size={16} className="mr-2" />
              {" "}PDF
            </button>
          </div>
        </div>

        {/* Table Section */}
        <div className="table-responsive">
          <table className="table .payment">
            <thead className="thead-payment">
              <tr>
                <th>Payment ID</th>
                <th>Brand Name</th>
                <th>Campaign Name</th>
                <th className="billing-date" onClick={toggleSort}>
                  BILLING DATE
                  <ChevronDown
                    size={16}
                    className={`ms-1 ${sortDirection === "desc" ? "rotate-180" : ""
                      }`}
                  />
                </th>
                <th>AMOUNT</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {currentRecords.map((payment) => (
                <tr key={payment.id}>
                  <td>{payment.id}</td>
                  <td>{payment.brandName}</td>
                  <td>{payment.campaignName}</td>
                  <td>{payment.billingDate}</td>
                  <td>{payment.amount}</td>
                  <td className="flex justify-center">
                    <span
                      className={`status-badge ${payment.status.toLowerCase()}`}
                    >
                      {payment.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        {/* {sortedPayments.length > 30 && currentRecords.length > 0 && (
          <div className="pagination-controls d-flex justify-content-between align-items-center mt-3">
            <div>
              Show
              <select
                value={recordsPerPage}
                onChange={handleRecordsPerPageChange}
                className="pagination-dropdown mx-2"
              >
                {[30, 60, 70, 80].map((perPage) => (
                  <option key={perPage} value={perPage}>
                    {perPage}
                  </option>
                ))}
              </select>
              Entries
            </div>
            <div>
              <button
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
                className="pagination-button mx-2"
              >
                Previous
              </button>
              <input
                type="text"
                readOnly
                value={currentPage}
                className="text-center pagination-input mx-2"
              />
              <button
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                className="pagination-button mx-2"
              >
                Next
              </button>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
}
